import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'
import { subcategoriesForCategory } from 'modules/expenses/hooks/useExpensesCustomization'
import { Expensable } from 'modules/expenses/types/Expensable'

export const buildPerDiemData = (
  expensable: Expensable,
  customizationFields: CustomizationField[],
  isOwnExpensable: boolean
) => {
  const showEmployeeInformation = !isOwnExpensable
  const employeeName = showEmployeeInformation ? expensable?.owner?.fullName : ''

  const perdiemSubcategories = subcategoriesForCategory(
    customizationFields,
    'perdiem',
    expensable?.perDiem?.category?.id ?? '',
    { includeHidden: true }
  )

  const subcategoryLabel =
    perdiemSubcategories.find(
      (subcategory) => subcategory.value === expensable?.perDiem?.subcategory
    )?.label ?? ''

  const items = [
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.information_block.expense_owner'),
      info: employeeName,
    },
    {
      title: i18n.t(
        'expenses_v2.confirmation_screen.expense.information_block.expense_subcategory'
      ),
      info: subcategoryLabel,
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}
